import { FeatureStatus } from "../featuresTypes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Chip } from "@mui/material"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { UnreachableCaseError } from "../../../../../lib/lang"
import React from "react"

export function FeatureStatusChip({ status }: { status?: FeatureStatus }) {
    if (!status) {
        return null
    }

    switch (status) {
        case FeatureStatus.NEW:
            return (
                <LocalizedStrict id="support-admin-features-status-label-new" attrs={{ label: true }}>
                    <Chip
                        label="NEW"
                        sx={{
                            borderRadius: ".5rem",
                            fontWeight: 500,
                            border: `1px solid ${tailwindPalette.indigo[300]}`,
                            backgroundColor: tailwindPalette.indigo[50],
                            color: tailwindPalette.indigo[700],
                        }}
                    />
                </LocalizedStrict>
            )
        case FeatureStatus.BETA:
            return (
                <LocalizedStrict id="support-admin-features-status-label-beta" attrs={{ label: true }}>
                    <Chip
                        label="BETA"
                        sx={{
                            borderRadius: ".5rem",
                            fontWeight: 500,
                            border: `1px solid ${tailwindPalette.sky[300]}`,
                            backgroundColor: tailwindPalette.sky[50],
                            color: tailwindPalette.sky[700],
                        }}
                    />
                </LocalizedStrict>
            )
        default:
            throw new UnreachableCaseError(status)
    }
}
